import * as zod from 'zod';

export const ZeroForceTorqueSensorVariables = zod.object({
  succeeded: zod.boolean(),
});

export type ZeroForceTorqueSensorVariables = zod.infer<
  typeof ZeroForceTorqueSensorVariables
>;
